import type { IModuleLogosFields } from "@types-contentful";
import { getColours, richTextHelper } from "@helpers";
import styled from "styled-components";

const MAX_LOGOS = 4;

const Container = styled.div<{
	resetModuleMarginBottom: "No" | "Yes" | undefined;
	backgroundColour: string | undefined;
}>`
  ${({ resetModuleMarginBottom }) =>
		resetModuleMarginBottom === "Yes" && "margin-bottom: 0px !important"};
  background-color: ${(props) => getColours(props.backgroundColour)};
  padding: 40px 35px 40px 35px;
  @media (min-width: 834px) {
    padding: 40px 10% 75px 10%;
  }
  overflow: hidden;
`;

const ContentsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  @media (min-width: 1172px) {
    flex-direction: row;
  }
`;

const LogosTitle = styled.div`
  margin-bottom: 24px;
  max-width: 400px;
`;

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem 2.5rem;
  justify-items: center;
  align-items: center;
  /* width: 100%; */
  /* max-width: 720px; */

  @media (min-width: 860px) {
    /* max-width: 900px; */
	grid-template-columns: repeat(4, minmax(0, 1fr));

  }
`;

const Image = styled.img`
  margin: 0 auto;
  /* max-width: 100px;
  max-height: 55px; */

  /* @media (min-width: 860px) { */
    max-width: 140px;
    max-height: 80px;
  /* } */
`;

const A = styled.a<{ noLinkProvided: boolean }>`
  cursor: ${({ noLinkProvided }) => noLinkProvided && "default"};
  display: flex;
  justify-content: center;
  align-items: center;
`;

type LogosType = { fields: { file: { url: string }; description: string } };
type CombinedItemType = [LogosType, string];

const LogoModuleNew = ({
	removeNegativeSpacingBelowModule,
	backgroundColour,
	title,
	logos,
	logoLinks,
}: IModuleLogosFields) => {
	const CombinedArray: CombinedItemType[] = [];

	if (logos && logoLinks) {
		for (let i = 0; i < logos.length && CombinedArray.length < MAX_LOGOS; i++) {
			if (logos[i] && logoLinks[i]) {
				CombinedArray.push([logos[i], logoLinks[i]]);
			}
		}
	}

	return (
		<Container
			resetModuleMarginBottom={removeNegativeSpacingBelowModule}
			backgroundColour={backgroundColour}
		>
			<ContentsContainer>
				<LogosTitle>{richTextHelper(title)}</LogosTitle>
				<LogoGrid>
					{CombinedArray.map((items: CombinedItemType, index: number) => (
						<A
							noLinkProvided={items[1] === "#"}
							href={items[1] !== "#" ? items[1] : undefined}
							key={`${items[0].fields.file.url}-${index}`}
							target="_blank"
							rel="noreferrer"
						>
							{/* biome-ignore lint/a11y/useValidAriaRole: <explanation> */}
							<Image
								src={`${items[0].fields.file.url}`}
								alt={
									items[0].fields.description
										? `${items[0].fields.description}${items[1] !== "#" ? " – learn more" : ""}`
										: "Not a link"
								}
								role="none"
								loading="lazy"
							/>
						</A>
					))}
				</LogoGrid>
			</ContentsContainer>
		</Container>
	);
};

export default LogoModuleNew;
